import axios from "axios";

export const fetchFeatured = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/products/featured`
  );
  return data;
};
